import React, { useEffect, useState } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { AutoCompleteSelect } from '../../../../components';
import { i18n } from '../../../../language';
import Dialog from '../../../../components/Dialog';
import { dutyAssignAPI } from '../../../../apis';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      padding: '0',
      margin: '0',
      boxShadow: 'unset',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1.875rem 1.875rem 1.563rem 1.587rem',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    margin: '-12px -12px 0 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
    marginBottom: '0.625rem',
  },
  infoIcon: {
    color: '#0e70a5',
    width: '1.25rem',
    height: '1.25rem',
    marginBottom: '0.5rem',
    marginLeft: '0.3rem',
  },
  main: {
    padding: '0 1.563rem',
    overflow: 'auto',
  },
  InputBase: {
    height: '3.75rem',
    borderRadius: '0.225rem',
    border: 'solid 1px #cccccc',
    width: '100%',
    paddingLeft: '1rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  labelError: {
    color: '#f44336',
  },
  inputError: {
    border: '1px solid #f44336',
  },
  errorMsg: {
    margin: '6px 0.125rem 0 0.125rem',
    color: '#f44336',
    fontSize: 12,
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  verify: {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#538fff',
    padding: '0.825rem',
  },
  alert: {
    '& .MuiAlert-standardSuccess': {
      // minWidth: '10rem',
      padding: '0.2rem 1rem',
    },
  },
  keyboardTimeInput: {
    paddingRight: '0',
    '& .MuiFormControl-root': {
      display: 'flex',
      justifyContent: 'center',
    },
    height: '3.5rem',
    width: '100%',
  },
  timeIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  addIcon: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
    marginRight: '0.6rem',
  },
  addBtn: {
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
  },
  deleteIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
    marginLeft: '1rem',
  },
}));

export default function BedStatusSetting({ closePop, open, oldData, confirmClick }) {
  const classes = useStyles();
  const loginInfo = useSelector((state) => state.loginInfo);
  const copyData = JSON.parse(oldData);
  const [bsTeamTypeList, setBsTeamTypeList] = useState([]);
  const [bsVisibleList, setBsVisibleList] = useState([]);

  const [inputValues, setInputValues] = useState({
    bsTeamType: copyData?.bsTeamType,
    bsVisible: copyData?.bsVisible,
  });

  useEffect(() => {
    getDropDownLists();
  }, []);

  const getDropDownLists = async () => {
    try {
      const emptyData = { value: -999, text: i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_SELECT_TEAM') };
      let bsTeamTypeList = [
        { value: 1, text: i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_TYPE1') },
        { value: 2, text: i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_TYPE2') },
        { value: 3, text: i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_TYPE3') },
        { value: 4, text: i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_TYPE4') },
      ];

      let bsVisibleList = [
        { value: 1, text: i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_VISIBLE_YES') },
        { value: 0, text: i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_VISIBLE_NO') },
      ];
      bsTeamTypeList.unshift(emptyData);
      bsVisibleList.unshift(emptyData);
      setBsTeamTypeList(bsTeamTypeList);
      setBsVisibleList(bsVisibleList);
    } catch (error) {
      console.log('-----Get chatroom list error----->', error);
    }
  };

  const handleBedStatusDialogConfirm = () => {
    const saveData = {
      bsTeamType: inputValues.bsTeamType,
      bsVisible: inputValues.bsVisible,
    };
    confirmClick(saveData);
    closePop();
  };

  return (
    <Dialog
      open={open}
      handleClose={closePop}
      handleCancel={closePop}
      handleConfirm={handleBedStatusDialogConfirm}
      title={i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TITLE')}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_CONFIRM')}
      cancelID="DutyAssign-Dialog-setHour-cancel"
      confirmID="DutyAssign-Dialog-setHour-confirm"
      closeID="DutyAssign-Dialog-setHour-close"
    >
      <Box display="flex">
        <Box width="50%" mr="1.275rem">
          <Typography id="setup-work-hour-start-time" className={classes.label}>
            {i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_TITLE')}
          </Typography>
          <AutoCompleteSelect
            value={inputValues.bsTeamType}
            placeholder={i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TEAM_TITLE')}
            itemList={bsTeamTypeList}
            onChange={(value) => {
              if (value === -999) {
                setInputValues({ ...inputValues, bsTeamType: null });
              } else {
                setInputValues({ ...inputValues, bsTeamType: value });
              }
            }}
            id="set_bed_status_team"
          />
        </Box>
        <Box width="50%">
          <Typography id="setup-work-hour-end-time" className={classes.label}>
            {i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_VISIBLE_TITLE')}
          </Typography>
          <AutoCompleteSelect
            value={inputValues.bsVisible}
            placeholder={i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_VISIBLE_TITLE')}
            itemList={bsVisibleList}
            onChange={(value) => {
              if (value === -999) {
                setInputValues({ ...inputValues, bsVisible: null });
              } else {
                setInputValues({ ...inputValues, bsVisible: value });
              }
            }}
            id="set_bed_status_visible"
          />
        </Box>
      </Box>
    </Dialog>
  );
}
